import { safeDocImageUrl } from "../../shared/operations-docs-maintenance";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { safeDocumentLink } from "./document-markdown";
import "./document.css";

/** Only page-scoped private images; no raw HTML, remote images, embeds, or scriptable links in authored documents. */
export function DocumentBody({
  markdown,
  pageId,
  imagePrefix,
}: {
  markdown: string;
  pageId?: string;
  imagePrefix?: string;
}) {
  const safeImage = (value: string | undefined) => {
    if (
      imagePrefix &&
      value?.startsWith(imagePrefix) &&
      /^\/api\/(?:workspaces\/[^/]+\/documents|ops\/customers\/[^/]+\/document-preview)\/[^/]+\/images\/$/.test(
        imagePrefix,
      ) &&
      /^[a-zA-Z0-9_-]+$/.test(value.slice(imagePrefix.length))
    )
      return value;
    return safeDocImageUrl(value, pageId);
  };
  return (
    <div className="document-prose">
      <Markdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        urlTransform={(value, key) =>
          (key === "src" ? safeImage(value) : safeDocumentLink(value)) ?? ""
        }
        components={{
          a: ({ href, children }) =>
            href ? (
              <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
              </a>
            ) : (
              <span>{children}</span>
            ),
          img: ({ src, alt }) =>
            safeImage(src) ? (
              <img src={src} alt={alt ?? "Document image"} loading="lazy" decoding="async" />
            ) : (
              <span className="text-muted-foreground">{alt ? `[Image: ${alt}]` : "[Image]"}</span>
            ),
          table: ({ children }) => (
            <div className="tableWrapper">
              <table>{children}</table>
            </div>
          ),
        }}
      >
        {markdown}
      </Markdown>
    </div>
  );
}
